import { Helmet } from "react-helmet"
import { useParams } from "react-router"
import React, { useEffect, useState } from "react"

import Config from "../../api/Config"
import { CreateType } from "./CreateType"
import { Attributes } from "./Attributes"
import { ASSETS } from "../../api/Registry"
import HttpServices from "../../services/HttpServices"
import { LoadingXL } from "../../components/utils/LoadingXL"
import { RouteHydration, classNames } from "../../utils/Helpers"
import { SideMenuMinified } from "../../components/layouts/SideMenuMinified"
import { SimplifiedHeader } from "../../components/layouts/SimplifiedHeader"
import { ModuleBreadCrumb } from "../../lib/fragments/ModuleBreadCrumb"
import { Link } from "react-router-dom"

export const AssetTypesListing = () => {
    const [state, setstate] = useState({
        reload: false,
        httpStatus: 200,
        status: 'pending',
        data: {
            types: null,
            category: null,
        },
        show: {
            createType: false,
            createCategory: false,
        }
    })

    const [activeType, setActiveType] = React.useState(null)
    const [selectedAssetType, setSelectedAssetType] = useState(null)
    const [newAssetType, setNewAssetType] = React.useState(null)

    let param = useParams()
    let pageTitle = "ASMX Categorization"

    const breadCrumb = [
        { linkItem: false, title: pageTitle },
    ]

    useEffect(() => {
        const fetchAssetTypes = async () => {
            let { status } = state
            let { httpStatus } = state

            let types = null
            let category = null

            try {
                let response: any = null
                let assetTypesRoute = null

                assetTypesRoute = RouteHydration(ASSETS.CATEGORY_TYPES, ':category', param.uuid)
                response = await HttpServices.httpGet(assetTypesRoute)

                httpStatus = response.status

                if (httpStatus === 200) {
                    const payload: any = response.data.payload

                    types = payload.types
                    category = payload.category

                    pageTitle = category.name
                    status = 'fulfilled'
                } else {
                    status = 'rejected'
                }
            } catch (error) {
                status = 'rejected'
                httpStatus = 500
            }

            setstate((prevState: any) => ({
                ...prevState, status,
                httpStatus,
                data: {
                    ...prevState.data,
                    types: types,
                    category: category
                },
            }));
        }

        fetchAssetTypes()
    }, [])

    const toggleCreateTypePanel = () => {
        setstate((prev) => ({
            ...prev,
            show: {
                ...prev.show,
                createType: !prev.show.createType
            }
        }))
    }

    const onCreateTypeComplete = (newType: any) => {
        toggleCreateTypePanel()
        setNewAssetType(newType)
    }

    const assetTypeSelector = (assetType: any) => {
        setActiveType(assetType)
        setSelectedAssetType(assetType)
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>
                    {pageTitle} - {Config.APP_NAME}
                </title>
            </Helmet>

            <div className="h-screen flex flex-col md:flex-row bg-theme from-[#ffffff] dark:from-slate-900 via-[#ffffff] dark:via-slate-700 via-[40%] dark:via-[60%] to-gradient dark:to-orange-900">
                {/* Top Nav Bar */}
                <SimplifiedHeader
                    customHeader={(() => {
                        const type = selectedAssetType

                        if (!type) {
                            return null
                        }

                        return (
                            <>
                                <p className="text-lg text-gray-800 dark:text-slate-200 font-medium text-start">
                                    {type.name}
                                </p>
                            </>
                        )
                    })()}
                />

                {/* Main Content Wrapper */}
                <div className="flex flex-col md:flex-row h-full md:h-full text-sm w-full overflow-y-auto">
                    {/* Side Menu */}
                    <SideMenuMinified ActiveMNu={'ASMX'} />

                    {
                        state.status === 'rejected' ? (
                            <>

                            </>
                        ) : state.status === 'fulfilled' ? (
                            <>
                                {/* Side Panel */}
                                <div className="md:h-full flex-none md:w-72 pt-14 w-full md:fixed md:left-16 px-1 border-r dark:border-slate-600 bg-inherit dark:bg-slate-00 md:overflow-y-auto">
                                    <div className="w-full px-3 pt-3 md:pt-2">
                                        <ModuleBreadCrumb breadCrumb={breadCrumb} />
                                    </div>

                                    <div className="bg-inherit dark:bg-inherit w-full">
                                        <div className="w-full bg-inherit px-3 pt-1">
                                            <h3 className="text-slate-900 dark:text-white font-medium tracking-wider text-xl">
                                                {state.data.category.name}
                                            </h3>

                                            <p className="text-slate-500 dark:text-slate-300 pt-3 pb-4 text-sm">
                                                <span className="block">
                                                    {state.data.category.description}
                                                </span>
                                            </p>

                                            <div className="flex w-full md:py-0 py-2 h-6 md:pb-2.5 md:px-0 px-0.5">
                                                <div className="md:w-8 w-8 justify-center flex items-end align-bottom text-slate-500 dark:text-slate-400">
                                                    <span className={`fa-light fa-cassette-betamax fa-xl`}></span>
                                                </div>
                                            </div>
                                        </div>

                                        <ul className="pr-3 text-sm overflow-hidden md:pb-0 pb-4 md:border-0 border-b-2 border-dashed border-gray-400">
                                            {
                                                state.data.types.length > 4 ? (
                                                    <li onClick={toggleCreateTypePanel} className={`w-full overflow-hidden text-sm md:h-12 h-14 flex items-center gap-x-`}>
                                                        <div className="md:w-12 md:h-12 w-14 h-14 flex flex-col items-center justify-center">
                                                            <div className="w-full h-1/2 flex items-center">
                                                                <div className="w-1/2 h-full"></div>

                                                                <div className="w-1/2 h-full rounded-bl-md border-l border-b border-slate-400"></div>
                                                            </div>

                                                            <div className="w-full h-1/2 flex items-center">
                                                                {/* <div className="w-1/2 h-full"></div>
                                                                <div className="w-1/2 h-10 border-l border-slate-400"></div> */}
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 rounded-md md:h-10 h-12 flex items-center px-2.5 hover:cursor-pointer text-orange-600 font-medium">
                                                            <h3 className="flex items-center align-middle gap-x-2">
                                                                <span className="fa-light fa-circle-plus fa-lg"></span>
                                                                Add Asset Type
                                                            </h3>
                                                        </div>
                                                    </li>
                                                ) : null
                                            }

                                            {
                                                newAssetType && (
                                                    <>
                                                        <li key={newAssetType.uuid} onClick={() => assetTypeSelector(newAssetType)} className="w-full overflow-hidden text-sm h-12 flex items-center gap-x-2">
                                                            <div className="w-12 h-12 flex flex-col items-center justify-center">
                                                                <div className="w-full h-1/2 flex items-center">
                                                                    <div className="w-1/2 h-full"></div>

                                                                    <div className="w-1/2 h-full rounded-bl-md border-l border-b border-slate-400"></div>
                                                                </div>

                                                                <div className="w-full h-1/2 flex items-center">
                                                                    <div className="w-1/2 h-full"></div>

                                                                    <div className="w-1/2 h-10 border-l border-slate-400"></div>
                                                                </div>
                                                            </div>

                                                            <div className={
                                                                classNames(
                                                                    activeType && activeType.uuid === newAssetType.uuid ? "bg-slate-200 dark:bg-slate-900" : "hover:bg-slate-100 dark:hover:bg-slate-700",
                                                                    "flex-1 rounded-md h-10 flex items-center px-2.5 hover:cursor-pointer"
                                                                )
                                                            }>
                                                                <h3 className="font-normal">
                                                                    {newAssetType.name}
                                                                </h3>
                                                            </div>
                                                        </li>
                                                    </>
                                                )
                                            }

                                            {
                                                state.data.types.map((type: any, index: any) => {
                                                    let { data } = state
                                                    const arrayLength = data.types.length
                                                    const isLastItem = (arrayLength - 1) === index ? true : false

                                                    return (
                                                        <>
                                                            <li key={type.uuid} onClick={() => assetTypeSelector(type)} className={`w-full overflow-hidden text-sm md:h-12 h-14 flex items-center gap-x-`}>
                                                                <div className="md:w-12 md:h-12 w-14 h-14 flex flex-col items-center justify-center">
                                                                    <div className="w-full h-1/2 flex items-center">
                                                                        <div className="w-1/2 h-full"></div>

                                                                        <div className="w-1/2 h-full rounded-bl-md border-l border-b border-slate-400"></div>
                                                                    </div>

                                                                    <div className="w-full h-1/2 flex items-center">
                                                                        {
                                                                            !isLastItem || arrayLength < 4 ? (
                                                                                <>
                                                                                    <div className="w-1/2 h-full"></div>

                                                                                    <div className="w-1/2 h-10 border-l border-slate-400"></div>
                                                                                </>
                                                                            ) : null
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className={
                                                                    classNames(
                                                                        activeType && activeType.uuid === type.uuid ? "bg-orange-200 text-slate-700 dark:bg-inherit dark:border dark:border-orange-400 dark:text-orange-500" : "hover:bg-slate-100 dark:hover:bg-slate-800",
                                                                        "flex-1 rounded-md md:h-10 h-12 flex items-center px-2.5 hover:cursor-pointer"
                                                                    )
                                                                }>
                                                                    <h3 className="font-normal">
                                                                        {type.name}
                                                                    </h3>
                                                                </div>
                                                            </li>
                                                        </>
                                                    )
                                                })
                                            }

                                            {
                                                state.data.types.length < 4 ? (
                                                    <li onClick={toggleCreateTypePanel} className={`w-full overflow-hidden text-sm md:h-12 h-14 flex items-center gap-x-`}>
                                                        <div className="md:w-12 md:h-12 w-14 h-14 flex flex-col items-center justify-center">
                                                            <div className="w-full h-1/2 flex items-center">
                                                                <div className="w-1/2 h-full"></div>

                                                                <div className="w-1/2 h-full rounded-bl-md border-l border-b border-slate-400"></div>
                                                            </div>

                                                            <div className="w-full h-1/2 flex items-center">
                                                                {/* <div className="w-1/2 h-full"></div>
                                                                <div className="w-1/2 h-10 border-l border-slate-400"></div> */}
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 rounded-md md:h-10 h-12 flex items-center px-2.5 hover:cursor-pointer text-orange-600 font-medium">
                                                            <h3 className="flex items-center align-middle gap-x-2">
                                                                <span className="fa-light fa-circle-plus fa-lg"></span>
                                                                Add Asset Type
                                                            </h3>
                                                        </div>
                                                    </li>
                                                ) : null
                                            }
                                        </ul>
                                    </div>
                                </div>

                                {/* Content Area */}
                                <div className={`md:flex-1 transition-all md:pt-14 md:py-2 py-4 md:ml-72 w-full md:h-full md:overflow-y-auto ${selectedAssetType ? "block" : " md:block"}`}>
                                    <Attributes
                                        category={state.data.category}
                                        type={selectedAssetType}
                                    />
                                </div>

                                <CreateType
                                    category={state.data.category}
                                    show={state.show.createType}
                                    onComplete={onCreateTypeComplete}
                                    showOrHide={toggleCreateTypePanel}
                                />
                            </>
                        ) : (
                            <div className="flex-grow w-full h-screen md:h-full flex flex-row py-4 justify-center align-middle items-center">
                                <LoadingXL />
                            </div>
                        )
                    }
                </div>
            </div>
        </React.Fragment>
    )
}